module.exports = __webpack_public_path__ + "media/images/flags/MS-82c6737bac31e71ceefa1de444955044.svg";